import { useMemo } from 'react';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import { useViewerStore } from '../../../../store/store';
import {
    computeSystemDesignMissingItems,
    type SystemDesignMissingItem,
} from './systemDesignMissingItems';

export function useSystemDesignMissingItems(): SystemDesignMissingItem[] {
    const opportunityDetails = useOneButtonStore((s) => s.opportunityDetails);
    const isOpportunityInitializing = useOneButtonStore((s) => s.isOpportunityInitializing);
    const solarUtilityData = useOneButtonStore((s) => s.solarUtilityData);
    const utilityCompanyName = useOneButtonStore((s) => s.utilityCompanyName);
    const utilityDetailsDirty = useOneButtonStore((s) => s.utilityDetailsDirty);
    const systemDesign = useOneButtonStore((s) => s.systemDesign);
    const systemDesignLosses = useOneButtonStore((s) => s.systemDesignLosses);
    const priceQuoteOverrides = useOneButtonStore((s) => s.priceQuoteOverrides);
    const priceQuoteDetails = useOneButtonStore((s) => s.priceQuoteDetails);
    const hoverJobId = useOneButtonStore((s) => s.hoverJobId);
    const SFannualUsage = useViewerStore((s) => s.SFannualUsage);

    return useMemo(() => {
        // Wait until opportunity init finishes — otherwise utility/design are still empty
        // and the FAB / badges flash false "missing" warnings mid-load.
        if (isOpportunityInitializing) return [];

        return computeSystemDesignMissingItems({
            opportunityDetails,
            solarUtilityData,
            utilityCompanyName,
            utilityDetailsDirty,
            sfAnnualUsage: SFannualUsage,
            systemDesign,
            systemDesignLosses,
            priceQuoteOverrides,
            priceQuoteDetails,
            hoverJobId,
        });
    }, [
        isOpportunityInitializing,
        opportunityDetails,
        solarUtilityData,
        utilityCompanyName,
        utilityDetailsDirty,
        SFannualUsage,
        systemDesign,
        systemDesignLosses,
        priceQuoteOverrides,
        priceQuoteDetails,
        hoverJobId,
    ]);
}
